import React, { Component } from 'react';
import { getQueryString } from 'utils';

import { global } from 'config';

export default class User extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: getQueryString('type')
        }
    }

    setName = () => {
        const { type } = this.state;

        let name = {
            'etxgs': '儿童学古诗',
            'etxcy': '儿童学成语',
            'yyqmeg': '英语启蒙儿歌',
            'klxcy': '快乐学成语',
            'cygs': '成语故事',
            'nppxgshd': '奶泡泡学古诗HD',             
        }
        // console.log(name[type]);

        if (!type) {
            return '呼呼收音机'
        } else {
            return name[type]
        }
    }

    setUrl = () => {
        const { type } = this.state;

        let url = {
            'etxgs': 'https://m.huhustory.com/?source=etxgs',
            'etxcy': 'https://m.huhustory.com/?source=etxcy',
            'yyqmeg': 'https://m.huhustory.com/etxeg',
        }
        // console.log(name[type]);

        if (!type) {
            return 'https://m.huhustory.com'
        } else {
            return url[type]
        }
    }

    handleComplaint = (type) => {
        window.location.href = global.href + "simple/complaint?type=" + type
    }

    handlePrivacy = (type) => {
        window.location.href = global.href + "simple/privacy?type=" + type
    }

    render() {
        const { type } = this.state;

        return (<div>

            <h3 style={{
                textAlign: 'center',
                fontWeight: 'bold',
                margin: '50px 0 20px',
                fontFamily: '宋体',
                color: '#000'
            }}>{this.setName()}用户协议</h3>
            <div style={{
                marginBottom: "20px",
                fontSize: '14px',
                fontFamily: '宋体',
                padding: '0 15px',
                color: '#000'
            }}>

                尊敬的用户：<br /><br />

                您好！<br /><br />

                感谢您选择杭州叽里咕噜文化传播有限公司提供的{this.setName()}产品与服务（简称“平台”、“{this.setName()}”或“{this.setName()}服务”）。在注册{this.setName()}账号及使用{this.setName()}服务前，请用户认真阅读、充分理解以下所述条款的内容，特别是加粗，具有限制、排除或者免除您的责任的条款。<br /><br />

                本服务协议的所有条款即构成您使用{this.setName()}所达成的协议（简称“本协议”），用于规范双方的权利和义务，保障双方合法权益。用户在使用{this.setName()}之前，请仔细阅读本协议，如用户不同意本服务协议的任何条款，请不要使用{this.setName()}产品与服务。您注册成为{this.setName()}用户，或实际使用{this.setName()}，即视为您已接受本协议的全部条款，本协议即开始生效。<br /><br />

                1. 定义<br /><br />

                1.1 “{this.setName()}”，是指杭州叽里咕噜文化传播有限公司开发运营的一款儿童内容产品平台（包括但不限于{this.setUrl()}网站及手机app）。<span style={{ fontWeight: 'bold', fontSize: '15px' }}>{this.setName()}依据本协议，为用户提供数据存储、管理、发布作品、分享的信息存储空间服务。</span><br /><br />

                1.2 “用户”，是指通过收听、观看等方式使用{this.setName()}服务及内容，或通过{this.setName()}发布图片、视听作品的创作者，包括但不限于自然人、法人或其他组织。<br /><br />

                1.3 “创作者”，是指在{this.setName()}上传、发布图片、视听等作品，或者通过{this.setName()}平台向用户提供其他内容服务的用户。<br /><br />

                1.4 “作品”，是指由创作者使用{this.setName()}上传、发布的其拥有完整著作权及相关权利的所有作品，包括但不限于创作者或获得授权的第三方创作的文字、图片、动画、歌曲、音频、视频作品等，或者上述几种作品形式的组合。<br /><br />

                2. 协议生效及变更<br /><br />

                2.1所有注册并使用{this.setName()}全部或部分服务的用户，应当首先同意本协议的所有条款。如果您不接受本协议，请不要使用{this.setName()}全部或部分服务。<br /><br />

                2.2 本协议是用户与{this.setName()}所订立的协议，在用户开通或使用某项特定服务时，可能会涉及某项服务的单独协议，所有单独协议为本协议不可分割的组成部分，与本协议具有同等法律效力。<br /><br />

                2.3 {this.setName()}保留依自主判断在将来的任何时间变更、修改、增加或删除本协议及条款的权利，一旦发生用户协议条款的变动，{this.setName()}将公示修改的内容，所有修改的内容均构成本协议的一部分。当用户使用{this.setName()}的任何服务时，应接受{this.setName()}随时提供的与该服务相关的规则或说明，并且此规则或说明均构成本用户协议的一部分。如果您不同意用户协议的修改，请立即主动取消、停止已经获得的服务；如果您继续使用{this.setName()}，则视为您已经接受用户协议的修改。<br /><br />

                3. 信息存储空间服务郑重声明<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>3.1 {this.setName()}郑重提请您注意，{this.setName()}向用户提供信息存储空间服务，所有用户账户上传、发布作品（以作品下方的用户账户为标志）均为用户自身行为与{this.setName()}无关。{this.setName()}无法对创作者传输、存储、发布的内容进行任何修改或编辑，无法对经由{this.setName()}信息存储空间服务上传、发布作品的内容以及创作者的上述行为进行控制，因此不保证作品的真实性、合法性、完整性，及不侵犯第三方权利。</span><br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>3.2 创作者有权使用{this.setName()}信息存储空间服务，发布节目均由创作者或者获得授权的第三方制作、上传及发布，包括录制音频、视频、动画片、背景音乐、歌曲、内容均由创作者自行提供。创作者承诺保证对其上传、发布的作品享有著作权及所有相关权利，不存在任何侵犯第三方合法权益（包括但不限于著作权、商标权、专利权、肖像权、人格权等）的情形，并保证其拥有合法充分的权利将作品通过{this.setName()}信息存储空间服务上传、发布、使用、复制、传播和供用户搜索、收听、观看和下载。声音节目及其内容如涉及到第三方的合法权利，创作者应在上传和发布之前获得相关权利人的授权。</span><br /><br />

                3.3 {this.setName()}非常重视和尊重版权及其他知识产权的保护，{this.setName()}已在本协议及其他协议中约定用户使用{this.setName()}不得侵害他人之合法权益，并尽商业上合理的注意义务设置相应的技术措施及规范防止用户通过{this.setName()}侵权他人之合法权益。<br /><br />

                如用户发现{this.setName()}中之任何内容涉嫌侵害其合法权益的，应按照作品页面“投诉”窗口进行投诉，并提供权属证明、初步侵权证据等所需材料，具体操作流程请查阅<span style={{ color: '#1890ff' }} onClick={() => this.handleComplaint(type)}>《{this.setName()}版权投诉指引》</span>。{this.setName()}将在收到投诉后的合理时间内按照法律法规及{this.setName()}的操作流程进行处理。<br /><br />

                3.4 如创作者所上传、发布的作品存在违法或侵权情形的，{this.setName()}在收到权利人之权利通知后会依法移除声音节目，并有权采取包括但不限于以下处罚措施：警告、限制或关闭账户、向投诉方或者司法机构提供您的注册信息等。<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>3.5 因作品或其内容引起的第三方投诉，由创作者自行解决并承担全部的法律责任，与{this.setName()}无关。若因作品侵权导致{this.setName()}承担赔偿责任的，创作者应赔偿{this.setName()}所遭受的所有损失，包括但不限于：赔偿款、诉讼费、律师费、公证费、差旅费等直接、间接损失。</span><br /><br />

                3.6 除创作者上传并发布内容外，平台内另有部分内容为{this.setName()}自主制作并发布（作品下方无用户账户标志）。{this.setName()}承诺对自制内容承担所有法律责任，并保证不存在侵犯第三方知识产权或其他权利的情形。<br /><br />

                4. 用户使用规则<br /><br />

                4.1  用户资格<br /><br />

                您确认，在您开始注册、使用{this.setName()}服务前，您具备中华人民共和国法律规定的与您行为相适应的民事行为能力。<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>如您未满18周岁，请在法定监护人的陪同下阅读本协议并得到法定监护人的同意方可注册使用。如您为未成年人法定监护人，请您合理设定未成年人娱乐时间，培养未成年人健康的生活习惯。</span><br /><br />

                4.2 非商业使用
                您承诺，您注册并使用{this.setName()}的行为仅为个人使用或家庭使用。未经{this.setName()}书面同意，用户不得利用{this.setName()}进行销售或其他商业使用等用途。<br /><br />

                4.3 合法使用<br /><br />

                （1）用户使用{this.setName()}时必须遵守中华人民共和国法律、法规和政策，不得利用{this.setName()}制作、复制、发布、传播如下内容：<br /><br />

                （a）违反宪法所确定的基本原则的；<br /><br />

                （b）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br /><br />

                （c）损害国家荣誉和利益的；<br /><br />

                （d）破坏国家宗教政策，宣扬邪教和封建迷信的；<br /><br />

                （e）散布谣言，扰乱社会秩序，破坏社会稳定的；<br /><br />

                （f）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br /><br />

                （g）侮辱或者诽谤他人，侵害他人合法权益的；<br /><br />

                （h）含有法律、法规和政策禁止的其他内容的信息。<br /><br />

                （2）{this.setName()}一直致力于为用户提供文明、健康、规范有序的网络环境，用户不得利用{this.setName()}从事以下行为：<br /><br />

                （a）诱导未成年人违法犯罪和渲染暴力、色情、赌博、恐怖活动的；<br /><br />

                （b）色情网站、成人用品网站等含有任何性或性暗示的内容；<br /><br />

                （c）国家明令禁止或未取得国家许可销售的产品，或假冒、伪劣产品或未经授权销售的产品；<br /><br />

                （d）贩卖虚拟货币，或非法集资、骚扰、垃圾广告或信息的；<br /><br />

                （e）撒布或者披露他人隐私、个人信息或资料的；<br /><br />

                （f）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；<br /><br />

                （g）其他侵犯其他用户或第三方合法权益的。<br /><br />

                （3）用户不得利用或者针对{this.setName()}平台软件实施以下行为：<br /><br />

                （a) 未经{this.setName()}书面许可，对{this.setName()}软件进行反向工程、反向汇编、反向编译或以其他方式获取{this.setName()}软件源代码；<br /><br />

                （b）未经{this.setName()}书面许可，对于{this.setName()}软件相关信息，擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，借助{this.setName()}软件发展与之有关的插件、外挂、兼容、互联等删除{this.setName()}软件及其他副本上所有关于版权的信息、内容；<br /><br />

                （c）一切非法利用第三方平台、工具或违反平台相关规定或其他不正当手段进行虚假注册、刷单、刷粉、点赞、评论、分享等行为；<br /><br />

                （d）使用{this.setName()}过程中，对{this.setName()}交互数据进行复制、更改、修改的；<br /><br />

                （e）利用{this.setName()}推广其他第三方运营平台或互相推广；<br /><br />

                （f）提交、发布虚假信息，或冒充、利用他人名义；<br /><br />

                （g）诱导、欺骗、强迫其他用户关注、点击链接页面或分享信息；<br /><br />

                （h）虚构、编造、散布虚假或片面事实，欺骗、误导他人的；<br /><br />

                （i）注册信息、申请认证资料与实际情况不一致的；<br /><br />

                （j）制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播的；<br /><br />

                （k）其他任何干扰{this.setName()}正常运营，或违反{this.setName()}平台规则和要求的；<br /><br />

                4.4 用户账号使用规范<br /><br />

                （1）用户应确保注册资料的真实性和准确性，并保证仅使用其个人信息或依法获得授权的信息注册{this.setName()}账号。如注册资料有任何变动，须及时更新，以便{this.setName()}确认您的身份，或为您提供密码找回等服务。<br /><br />

                （2）用户根据要求完成注册申请后，可获得特定{this.setName()}账号的使用权。<br /><br />

                （3）{this.setName()}特别提醒您妥善保管您的用户名和密码，不要将您的账号信息透露给任何其他人，不要向他人透露、复制、转让注册账户或授权许可他人使用注册账户。<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>（4）您通过用户名、密码或手机号、验证码或您同意授权的第三方平台账户登录您的{this.setName()}账户的，{this.setName()}将该登录行为视为系您亲自实施。您将对此承担所有的法律责任。</span><br /><br />

                （5）如果您超过720天未使用、或停止使用本服务或服务被终止或取消，{this.setName()}有权回收账号且无需事先通知您即可从服务器上永久地删除用户的数据。服务停止、终止或取消后，{this.setName()}没有义务向用户返还任何数据。用户同意{this.setName()}有权行使上述权利且不需对用户或第三方承担任何责任。<br /><br />

                4.5 关于用户名和昵称使用：<br /><br />

                （1）不得使用党和国家领导人或其他知名人士的真实姓名、字号、艺名、笔名作为用户名和昵称；<br /><br />

                （2）不得使用国家机构或其他机构的名称作为用户名和昵称；<br /><br />

                （3）不得使用和其他知名网友之名相同或近似的用户名和昵称；<br /><br />

                （4）不得使用不文明、不健康，或带攻击性、侮辱性的用户名和昵称；<br /><br />

                （5）请勿使用易产生歧义、引起他人误解的用户名和昵称；<br /><br />

                （6）不得使用其他具有不良影响的用户名和昵称；<br /><br />

                对于违反以上规定或产生不良后果的用户名和昵称，{this.setName()}有权删除而不必事先通知。<br /><br />

                4.6 关于发表及评论内容规则<br /><br />

                （1）遵守相关法规，严禁发表违反法律法规及社会主义道德规定的内容；<br /><br />

                （2）使用文明用语，不得张贴对任何人进行人身攻击、谩骂、诋毁的言论；<br /><br />

                （3）不得张贴未经公开报道、未经证实的消息；<br /><br />

                （5）不得张贴与作品无关的消息、言论和视听评论；<br /><br />

                对于违反以上规定的内容，在不需要通知和解释的情况下，{this.setName()}有权予以删除，并根据违规情节作出处罚措施。<br /><br />

                5. 知识产权<br /><br />

                5.1 {this.setName()}系独立开发完成，其产品、服务所涉及的著作权、商标权、专利权、商业秘密等知识产权、其他相关权利均独立归属{this.setName()}所有。与{this.setName()}相关的所有信息，包括但不限于：{this.setName()}商标标识、网页/产品版面设计、界面设计、图标、文字表述、数据、代码、电子文档及其组合等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护。<br /><br />

                5.2 用户使用{this.setName()}只能在本协议以及相应的授权许可范围内使用{this.setName()}的知识产权，未经授权禁止任何超范围使用行为, 不论是否以商业为目的。<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>5.3 用户点击同意本协议或通过{this.setName()}上传、发布、共享作品的行为，即视为用户对发布作品向{this.setName()}作出复制权、改编权、汇编权、信息网络传播权授权，用户确认其将该作品以无偿、非排他性、永久性授权{this.setName()}使用。{this.setName()}合作伙伴或用户有权在{this.setName()}平台或开放或合作的API/SDK 平台（如有）进行搜索、收听、观看、下载、分享、展示、传播。</span><br /><br />

                6. 隐私政策<br /><br />

                {this.setName()}非常重视您的隐私和个人信息，为此我们专门制定了<span style={{ color: '#1890ff' }} onClick={() => this.handlePrivacy(type)}>《{this.setName()}隐私政策》</span>，希望向您说明我们在您使用{this.setName()}时收集何种信息以及如何收集、使用和保护这些信息。<br /><br />

                在使用{this.setName()}前，请您务必仔细阅读我们的隐私政策。除非您已阅读并接受本协议的全部条款，否则请您立即停止使用{this.setName()}。一旦您选择注册{this.setName()}账号或以第三方平台账号登录或实际使用{this.setName()}，即视为您已充分理解并接受本隐私政策。<br /><br />

                7. 责任限制与不可抗力<br /><br />

                7.1 {this.setName()}按照现有技术和条件所能达到的现状向用户提供服务，并尽最大努力确保服务的安全性和稳定性。{this.setName()}不担保所提供的网络服务一定能满足用户的要求，也不保证提供的信息存储空间容量充足或其提供的网络服务不会被中断，且对服务的及时性、安全性、准确性，以及信息是否能准确、及时、顺利的传送均不作任何保证，也不承担任何法律责任，但{this.setName()}将尽力减少因此给用户造成的损失和影响。<br /><br />

                7.2 为了向用户提供优质服务，{this.setName()}有权不经用户同意而变更、改变、删除、增加服务，也可能暂停或彻底终止本服务，而不承担任何法律责任。<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>7.3 用户理解，{this.setName()}审核用户注册信息以及作品仅仅是对此类信息的形式审查，{this.setName()}没有能力也不可能对用户的注册信息和上传的作品是否真实、合法、是否侵权等方面进行实质审查。{this.setName()}对用户之注册信息及其上传、发布的作品不做任何保证，也不因此承担任何形式的法律责任。</span>{this.setName()}对用户经由{this.setName()}提供的服务所获得的信息亦不做任何保证，包括真实性、合法性、非侵权性等，尤其是用户通过{this.setName()}提供的服务获得的商业广告信息、交友信息等。用户须自行甄别信息的真实性并谨慎预防可能存在的风险，因此而产生的任何直接、间接、偶然、附带或衍生的损失或损害，{this.setName()}不承担任何责任。<br /><br />

                7.4 用户理解，{this.setName()}容易受到互联网安全问题的困扰，并由于互联网技术的不稳定性，可能遭遇基础电信运营商移动通信网络的故障、技术缺陷、覆盖范围限制、不可抗力、计算机病毒、黑客攻击、服务器系统崩溃等风险，上述风险可能导致{this.setName()}中断或数据损失，{this.setName()}对此等不可抗力因素导致的损失不承担责任。<br /><br />

                8. 通知<br /><br />

                所有发给用户的通知都可通过手机短信、电子邮件、系统通知、私信、或页面公告等方式进行传送。{this.setName()}将通过上述方法之一将消息传递给用户，告知他们服务条款的修改、服务变更及其他事项等。<br /><br />

                9. 法律责任<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>9.1 如果发现或收到他人举报或投诉用户违反本协议约定的，{this.setName()}有权不经通知随时对相关内容进行删除，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用全部或部分服务功能、扣除部分或全部虚拟收益、暂时或永久冻结封禁账号、回收注销账号及清零等。</span><br /><br />

                9.2 用户理解并同意，{this.setName()}有权依合理判断对违反有关法律法规或本协议、平台规则规定的行为进行处罚，对违法违规行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告、起诉等，用户应独自承担由此而产生的一切法律责任。<br /><br />

                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>9.3 用户理解并同意，因用户违反本协议或相关的服务条款的规定，导致或产生的平台、任何第三方的任何损失，包括但不限于：诉讼费、律师费、公证费、差旅费、赔偿款、罚款等直接、间接损失，用户应当全额赔偿{this.setName()}及第三方的全部损失。</span><br /><br />

                10. 法律适用及管辖<br /><br />

                您同意与本协议相关的一切争议，均提交至{this.setName()}所在地有管辖权法院司法管辖。

            </div>
        </div>);
    }
}